var ollehModule = null
var loader = (callback) => {
    var head= document.getElementsByTagName('head')[0];
    var script= document.createElement('script');
    script.type= 'text/javascript';
    script.onreadystatechange = function () { // IE
        if (this.readyState === 'complete') callback();
    }
    script.onload = callback;
    script.src = 'mapCustom.js?v=1.0';
    head.appendChild(script);
}

ollehModule = eval('olleh')

export {ollehModule, loader}